import React, { useState, useEffect } from "react";
import SaveButton from "@/ui-controls/SaveButton";
import CancelButton from "@/ui-controls/CancelButton";
import TextInput from "@/ui-controls/TextInput";
import AddButton from "@/ui-controls/AddButton";
import { Grid } from "fluentui-react-grid";
import {
  Application,
  ApplicationCustomers,
  addApplicationCustomers,
} from "@/api/applications";
import { Customer } from "@/api/customers";
import CustomerSelectDetailList from "@/components/customers/CustomerSelectDetailList";
import NewCustomerForm from "@/components/customers/NewCustomerForm";

interface Props {
  application: Application;
  allCustomers: Customer[];
  nonAppCustomers: Customer[];
  onAddNewCustomer?: (customer: Customer) => any;
  onSave?: (newAppCustomer: ApplicationCustomers) => any;
  onClose?: () => any;
}

const NewAppCustomerForm = (props: Props) => {
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [showNewCustomerForm, setShowNewCustomerForm] =
    useState<boolean>(false);
  const [filteredCustomers, setFilteredCustomers] = useState<Customer[]>([]);
  const [selectedCustomers, setSelectedCustomers] = useState<Customer[]>([]);
  const [filteredCustomerValue, setFilteredCustomerValue] = useState<
    string | undefined
  >(undefined);

  useEffect(() => {
    return () => {};
  }, []);

  useEffect(() => {
    filterCustomers(filteredCustomerValue);
  }, [props.nonAppCustomers]);

  const onCancelForm = () => {
    if (props.onClose) props.onClose();
  };

  const saveApplicationCustomer = () => {
    setIsSaving(true);

    const appCustomers: ApplicationCustomers = {
      AppId: props.application.Id,
      CustomerIds: selectedCustomers.map((c) => c.Id),
    };

    addApplicationCustomers(appCustomers).then(
      (_) => {
        setIsSaving(false);
        if (props.onSave) props.onSave(appCustomers);
      },
      (error) => {
        setIsSaving(false);
        handleError(error);
      }
    );
  };

  const onFilter = (
    ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    text: string | undefined
  ) => {
    setFilteredCustomerValue(text);
    filterCustomers(text);
  };

  const filterCustomers = (text: string | undefined) => {
    setFilteredCustomers(
      text
        ? props.nonAppCustomers.filter(
            (i) => i.Name.toLowerCase().indexOf(text.toLowerCase()) > -1
          )
        : props.nonAppCustomers
    );
  };

  const validateCustomerToAdd = (name: string | undefined) => {
    return (
      name &&
      !props.allCustomers.find(
        (c) => c.Name.toLowerCase() === name.toLowerCase()
      )
    );
  };

  const handleError = (error: any) => {
    // Error handling would go here in real app
  };

  return (
    <>
      {showNewCustomerForm && filteredCustomerValue ? (
        <NewCustomerForm
          // TODO: refactor this name={filteredCustomerValue}
          onClose={() => {
            setShowNewCustomerForm(false);
            filterCustomers(filteredCustomerValue);
          }}
          onSave={(newCustomer) => {
            setShowNewCustomerForm(false);
            if (props.onAddNewCustomer) props.onAddNewCustomer(newCustomer);
          }}
        />
      ) : null}
      <div style={{ display: showNewCustomerForm ? "none" : "block" }}>
        <Grid dir="ltr">
          <Grid.Row>
            <Grid.Col sizeSm={12}>
              <TextInput
                label="Filter customer:"
                baseTypeProps={{
                  onChange: onFilter,
                }}
              />
              {validateCustomerToAdd(filteredCustomerValue) ? (
                <div
                  style={{
                    position: "absolute",
                    top: "29px",
                    right: "8px",
                  }}
                >
                  <AddButton
                    text="Add"
                    onClick={() => setShowNewCustomerForm(true)}
                    baseTypeProps={{ disabled: isSaving }}
                  />
                </div>
              ) : null}
            </Grid.Col>
          </Grid.Row>
          <Grid.Row>
            <CustomerSelectDetailList
              CustomerList={filteredCustomers}
              onSelectionChanged={(customers) => {
                setSelectedCustomers(customers);
              }}
            />
          </Grid.Row>
          <Grid.Row className="panel-buttons">
            <Grid.Col>
              <SaveButton
                text="Save"
                baseTypeProps={{
                  disabled:
                    isSaving ||
                    !selectedCustomers ||
                    selectedCustomers.length < 1,
                }}
                onClick={() => saveApplicationCustomer()}
              />
            </Grid.Col>
            <Grid.Col>
              <CancelButton
                text="Cancel"
                onClick={onCancelForm}
                baseTypeProps={{ disabled: isSaving }}
              />
            </Grid.Col>
          </Grid.Row>
        </Grid>
      </div>
    </>
  );
};

export default NewAppCustomerForm;
